import React, { lazy, Suspense } from 'react';

import Typography from 'antd/es/typography';

import './style';

const Row = lazy(() => import('antd/es/row'));
const Col = lazy(() => import('antd/es/col'));
const Divider = lazy(() => import('antd/es/divider'));

const CommunityOutline = lazy(() => import('#components/communities/CommunityOutline'));
const CommunityMembershipList = lazy(() => import('#components/communities/CommunityMembershipList'));
const CommunityTeamList = lazy(() => import('#components/communities/CommunityTeamList'));

const { Link } = Typography;

class ShowContainer extends React.Component {
  render() {
    const { community, communityType, users, communityTeams, token } = this.props

    const shouldShowMoreMemberships = community.membershipsCount > 5
    const showMoreMembership = (
      shouldShowMoreMemberships && <Link href={`/me/communities/${community.id}/community_memberships`}>Show more members</Link>
    )

    return (
      <Suspense fallback={null}>
        <React.Fragment>
          <CommunityOutline community={community} communityType={communityType} />

          <Divider />

          <Row gutter={16}>
            <Col span={16}>
              <CommunityMembershipList
                community={community}
                users={users}
                showMore={showMoreMembership}
              />
            </Col>

            <Col span={8}>
              <CommunityTeamList community={community} communityTeams={communityTeams} token={token} />
            </Col>
          </Row>
        </React.Fragment>
      </Suspense>
    )
  }
}

export default ShowContainer;
